/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：1762
 */

"use strict"

var r = require(/* 257 */"./1754/257/index")
var /* [auto-meaningful-name] */require_828_$_1761_828$indexOf = require(/* 828 */"./1761/828").indexOf
var /* [auto-meaningful-name] */r$aTypedArray = r.aTypedArray;
(0, r.exportTypedArrayMethod)("indexOf", function (e) {
  return require_828_$_1761_828$indexOf(r$aTypedArray(this), e, arguments.length > 1 ? arguments[1] : undefined)
})
